import { useSnackbar } from "notistack";
import { Box } from "@mui/material";
import PropTypes from "prop-types";

import { backendPatch } from "@accredo/fe-shared/services/dataService.js";
import Form from "@accredo/fe-shared/components/Form/Form.jsx";
import FormDetailedRadioGroup from "../../../components/Form/controls/FormDetailedRadioGroup.jsx";
import SubmitButton from "@accredo/fe-shared/components/Form/controls/SubmitButton.jsx";

const notificationOptions = [
  {
    key: "einzeln",
    label: "Einzeln",
    detail: "Sie erhalten für jede Aktualisierung eine separate E-Mail.",
  },
  {
    key: "taeglich",
    label: "Täglich",
    detail:
      "Bei Aktualisierungen erhalten Sie einmal am Tag eine Zusammenfassung per E-Mail.",
  },
  {
    key: "keine",
    label: "Keine",
    detail:
      "Das Schadenportal sendet Ihnen keine E-Mails. Sie sollten sich deshalb regelmäßig im Schadenportal anmelden um keine Aktualisierung zu verpassen.",
  },
];

const NotificationSettingsSection = ({ userData, setUser }) => {
  const { enqueueSnackbar } = useSnackbar();

  const onSubmit = async (data, formMethods) => {
    let success = false;
    await backendPatch("data/user/account", {
      toSend: data,
      label: "Benachrichtigungseinstellungen",
      enqueueSnackbar,
      setError: formMethods.setError,
      successMessage: "Einstellungen erfolgreich gespeichert.",
      onSuccess: (response) => {
        if (response.user) {
          setUser(response.user);
          success = true;
        }
      },
    });
    return success;
  };

  return (
    <Box>
      <Form
        onSubmit={onSubmit}
        defaultValues={{
          level_benachrichtigung:
            userData?.level_benachrichtigung || "taeglich",
        }}
      >
        <FormDetailedRadioGroup
          name="level_benachrichtigung"
          label="Wie möchten Sie über Aktualisierungen im Schadenportal informiert werden?"
          options={notificationOptions}
        />
        <Box sx={{ mt: 4 }}>
          <SubmitButton>Speichern</SubmitButton>
        </Box>
      </Form>
    </Box>
  );
};

NotificationSettingsSection.propTypes = {
  userData: PropTypes.shape({
    level_benachrichtigung: PropTypes.string,
  }).isRequired,
  setUser: PropTypes.func.isRequired,
};

export default NotificationSettingsSection;
